import { convert } from '../async';
import { getJson } from './http';

export default function getPlatformId(providerId, setPlatformId) {
    return getJson(`/api/operational-tool/id-mapping/${encodeURIComponent(providerId)}`, (result) => {
        const platformId = convert(result, (source) => source[0].platformId);
        setPlatformId(platformId);
    });
}
